import { Link, useLocation } from 'react-router-dom';

/**
 * Anything else.
 *
 * CloudFront rewrites unknown paths to index.html so the router can answer them,
 * which means a genuinely wrong URL arrives here rather than at a 404 page. It
 * has to say so itself.
 *
 * It lives in its own file because the operator console renders *this component*
 * for a non-operator (D-20), and the two must be the same thing rather than two
 * pages that look alike. A copy would eventually diverge — a stray word, a
 * different heading — and the divergence would be the tell that `/admin` exists.
 * Importing it from `App.tsx` instead would make App and the console a cycle.
 */
export default function NotFound() {
  const { pathname } = useLocation();
  return (
    <section className="hero">
      <h1>404</h1>
      <p className="lede">
        <code>{pathname}</code>
      </p>
      <p>
        <Link to="/">nabu.guru</Link>
      </p>
    </section>
  );
}
